import { Link } from 'react-router-dom';
import './Services.css';

function ItemsWeTakeIcon() {
  return (
    <svg
      className="service-illustration"
      viewBox="0 0 160 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <ellipse cx="80" cy="108" rx="48" ry="6" fill="#e8eaee" />
      <circle cx="80" cy="58" r="34" fill="#eaf6e4" />
      <circle cx="80" cy="58" r="28" stroke="#7dbb61" strokeWidth="5" />
      <path
        d="M64 58.5l10 10 22-24"
        stroke="#5f9a45"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ItemsWeDontTakeIcon() {
  return (
    <svg
      className="service-illustration"
      viewBox="0 0 160 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <ellipse cx="80" cy="108" rx="48" ry="6" fill="#e8eaee" />
      <circle cx="80" cy="58" r="34" fill="#f3f4f6" />
      <circle cx="80" cy="58" r="28" stroke="#9ca3af" strokeWidth="5" />
      <path d="M68 46l24 24M92 46L68 70" stroke="#6b7280" strokeWidth="6" strokeLinecap="round" />
    </svg>
  );
}

const SERVICES = [
  {
    id: 'take',
    title: 'Items we take',
    caption: 'Metals and scrap we can collect',
    to: '/items-we-take',
    icon: <ItemsWeTakeIcon />,
  },
  {
    id: 'dont-take',
    title: "Items we don't take",
    caption: 'Materials we cannot collect',
    to: '/items-we-dont-take',
    icon: <ItemsWeDontTakeIcon />,
  },
];

export default function Services() {
  return (
    <section className="services" aria-labelledby="services-heading">
      <div className="services-inner">
        <header className="services-header">
          <h2 id="services-heading">Popular Scrap Removal Services</h2>
          <p>Professional &amp; fast scrap metal collection in Leeds</p>
        </header>

        <div className="services-grid">
          {SERVICES.map((service) => (
            <Link key={service.id} className="service-card" to={service.to}>
              <h3>{service.title}</h3>
              <div className="service-media">{service.icon}</div>
              <p>{service.caption}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
